// Vendor imports
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const Icon = require('client-v2/common/containers/icons/component')
const tag = require('client-v2/common/utils/hyperscript')
// Entry imports
const DownloadLinks = require('client-v2/into-landing/containers/download-links/component-smart')

const bem = BemEntity('IntoLinkModal')

function IntoLinkModal(props) {
  const { caption, isLinkModalDismissed, onLinkModalDismiss } = props
  return (
    tag('div', {
      className: classNames(
        props.className,
        bem.block({
          dismissed: isLinkModalDismissed
        })
      )
    },
      tag('button', {
        className: bem.element('close-button'),
        onClick: onLinkModalDismiss
      },
        tag(Icon, { id: 'x' })
      ),
      !caption && tag('div', {
        className: bem.element('caption')
      },
        'The best content from the open web, personalized to you.'
      ),
      caption,
      tag(DownloadLinks, {
        className: bem.element('download-links')
      })
    )
  )
}

module.exports = IntoLinkModal
